<template>
  <div
    :class="this.searchActive? 'header active': 'header'"
  >
    <SearchBar :modal.sync="modal"/>
        <transition name="fade">

    <LoginModal v-if='modal'/>
        </transition>
    <div
      class="header__container"
      v-bind:style="{ backgroundImage: 'url(' + chooseBackground(topNumber)  + ')' }">
      <a
        href="https://www.polskieradio.pl/9,Trojka"
        target="_blank"
        tabindex="0"
        aria-label="Trójka"
      >
        <div class="header__trojka-logo">
        </div>
      </a>
      <div
        class="header__number-of-top"
        v-if="showTopNumber(topNumber)"
      >
        {{topNumber}}
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar/Desktop/SearchBar.vue";
import LoginModal from "@/components/LoginModal/Desktop/LoginModal.vue";
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SearchBar,
    LoginModal
  },
  data() {
    return {

    }
  }


}
</script>

<style scoped lang="scss">
  .header {
    width: 100%;
    height: 38rem;
    background-position: top;
    background-size: 66%;
    background-repeat: no-repeat;
    background-color: #1a1e2a;
    transition: height .2s linear;

     &.active {
   height:  40.8125rem;
      }
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
    &__container {
      width: 100%;
      height: 100%;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      background-repeat: no-repeat;
      background-position: top;
      background-size: 100%;
    }
    a {
      z-index: 2;
          display: block;
    width: 9rem;
    }
    &__trojka-logo {
      width: 9rem;
      height: 3rem;
      margin-top: 2rem;
      background-image: url('/icons/trojka.png');
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    &__trojka-banner {
      width: 42.45rem;
      height: 26.375rem;
      margin-top: -6rem;
      background-image: url('/img/banner.png');
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
    }
    &__number-of-top {
      background-image: url('/img/topBlock.png');
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
      font-family: 'Poppins', sans-serif;
      color: #fff;
      font-weight: 700;
      font-size: 3.75rem;
      position: relative;
      left: 22%;
      top: 2%;
      width: 8.75rem;
      height: 5.625rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
